import React from 'react'
import { POSTFIX_REPOSITORY, PREFIX_REPOSITORY } from '../../../../constants/URLs';
import ListDownload from '../../../listDownload/listDownload';

const dataDescargas = [
  {
    title: 'Composición por cartera administrada',
    size: '1.5 MB',
    download:
      PREFIX_REPOSITORY +
      '2022/pdf/' +
      'Reporte_Julio_2022.pdf' +
      POSTFIX_REPOSITORY,
  },
]

const DocumentosInformativosYFormatos = () => {
  return (
    <div className={'containerWrap'}>
      <h2 className="tw-mt-0 tw-mb-6 tw-mb-12@lg center w-80 w-auto@lg ml-auto mr-auto font-family-secondary c-turquoise-0 fw-7 tw-f-20 tw-f-24@lg">
        Documentos informativos y formatos
      </h2>

      <div className={`flex flex-wrap justify-center`}>
        {dataDescargas.map(({ title, size, download }) => (
          <ListDownload
            GTMOption={{
              section: 'en que invierten mi dinero',
              sub_section: 'Documentos informativos y formatos',
              option: '',
              location: '/aportes-y-fondo/en-que-invierten-mi-dinero/',
            }}
            title={title}
            size={size}
            download={download}
            key={title}
          />
        ))}
      </div>
    </div>
  )
};

export default DocumentosInformativosYFormatos;
